import {
  cptFlagDescriptors,
  isFreeCptRate,
  normalizedDuration,
} from './service-facet-helpers/flag-descriptors';
import { parseCommaSeparatedStrings } from './comma-query-param';

const FILTER_DETAIL = 'booking.clinicianSearch.filterDetail';

function disambigLeaf(descriptor) {
  switch (descriptor.kind) {
    case 'duration':
      return ['cptDurationMinutes', { count: descriptor.minutes }];
    case 'rate':
      return ['cptFlagRate', { rate: descriptor.rate }];
    case 'callToBook':
      return [descriptor.yes ? 'cptFlagCallToBookYes' : 'cptFlagCallToBookNo'];
    case 'requireCreditCardForNewClients':
      return ['cptFlagCredit', { state: descriptor.state }];
    default:
      return null;
  }
}

function formatDisambigPart(descriptor, intl) {
  let leaf = disambigLeaf(descriptor);
  if (!leaf) {
    return null;
  }
  let [leafKey, values] = leaf;
  return intl.t(`${FILTER_DETAIL}.${leafKey}`, values);
}

function fallbackRateLabel(fallbackKey, intl) {
  return intl.t(`${FILTER_DETAIL}.cptRateLabel`, {
    id: String(fallbackKey ?? ''),
  });
}

function freeRateBaseLabel(displayDesc, intl) {
  return intl.t(`${FILTER_DETAIL}.cptOptionFreeLine`, {
    description: displayDesc,
  });
}

function durationBaseLabel(displayDesc, duration, intl) {
  return intl.t(`${FILTER_DETAIL}.cptOptionWithDuration`, {
    description: displayDesc,
    minutes: duration,
  });
}

function cptOptionBaseLabel({ desc, displayDesc, duration, rate, fallbackKey }, intl) {
  if (isFreeCptRate(rate)) {
    return { base: freeRateBaseLabel(displayDesc, intl), skipKeys: new Set() };
  }

  let dur = normalizedDuration(duration);
  if (displayDesc && dur !== null) {
    return { base: durationBaseLabel(displayDesc, dur, intl), skipKeys: new Set(['duration']) };
  }

  return { base: desc || fallbackRateLabel(fallbackKey, intl), skipKeys: new Set() };
}

export function cptServiceOptionLabelForDisplay(source, intl, { fallbackKey, flaggedKeys } = {}) {
  let { description, duration, rate, callToBook, requireCreditCardForNewClients } = source ?? {};
  let resolvedFallbackKey = fallbackKey ?? '';
  let desc = String(description ?? '').trim();
  let displayDesc = desc || intl.t(`${FILTER_DETAIL}.cptGroupFallback`);
  let { base, skipKeys } = cptOptionBaseLabel(
    { desc, displayDesc, duration, rate, fallbackKey: resolvedFallbackKey },
    intl
  );

  let attrs = { description, duration, rate, callToBook, requireCreditCardForNewClients };
  let extraParts = cptFlagDescriptors(attrs, flaggedKeys ?? [], { skipKeys }).map(d =>
    formatDisambigPart(d, intl)
  );
  if (extraParts.length) {
    return intl.t(`${FILTER_DETAIL}.cptOptionDisambig`, {
      base,
      extra: extraParts.join(', '),
    });
  }

  return base;
}

export function serviceText(q, { store, clinicianSearch, intl }) {
  let id = parseCommaSeparatedStrings(q.cptCodes)[0];
  if (!id) {
    return '';
  }

  let code = clinicianSearch.sendAll.isLoaded ? store.peekRecord('cpt-code', id) : null;
  return code
    ? cptServiceOptionLabelForDisplay(code, intl, { fallbackKey: id })
    : intl.t('booking.clinicianSearch.filterDetail.cptGroupFallback');
}
